import { render, staticRenderFns } from "./DynamicRecordHistory.vue?vue&type=template&id=3bdb5d6d&"
import script from "./DynamicRecordHistory.vue?vue&type=script&lang=js&"
export * from "./DynamicRecordHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bdb5d6d')) {
      api.createRecord('3bdb5d6d', component.options)
    } else {
      api.reload('3bdb5d6d', component.options)
    }
    module.hot.accept("./DynamicRecordHistory.vue?vue&type=template&id=3bdb5d6d&", function () {
      api.rerender('3bdb5d6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/RecordHistory/DynamicRecordHistory.vue"
export default component.exports